import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  layerPremium: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  layerPremiumTitleWrapper: {
    marginRight: theme.spacing(2),
  },
  layerPremiumTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    margin: 0,
  },
  layerPremiumDetails: {
    fontSize: '10px',
    marginBottom: theme.spacing(0.25),
  },
}));
